import { DiscoveryProduct } from '@teko/discovery';
import { isDisplayBrandByTenant, isDisplayUomByTenant } from 'helpers';
import { useCallback } from 'react';
import {
  useTenantConfig,
  useCart,
  useFrame,
  useHelper,
  useGlobalData,
} from '../contexts';

export const useConvertProductCard = () => {
  const { allowAddToCartFromListing, contactLink } = useTenantConfig();
  const { productHelper } = useHelper();
  const { frames } = useFrame();
  const cart = useCart();
  const convertProductCard = useCallback(
    (el: DiscoveryProduct) =>
      allowAddToCartFromListing
        ? {
            ...productHelper.convertProductCard(el, { cart, frames }),
            contactLink,
          }
        : productHelper.convertProductCard(el, { frames }),
    [cart, frames],
  );
  return { convertProductCard };
};

export const useNewProductCard = () => {
  const { allowAddToCartFromListing, contactLink } = useTenantConfig();
  const { productHelper } = useHelper();
  const { frames } = useFrame();
  const cart = useCart();
  const { tenant } = useGlobalData();
  const hasBrand = isDisplayBrandByTenant(tenant);
  const showUom = isDisplayUomByTenant(tenant);
  const convertNewProductCard = useCallback(
    (el: DiscoveryProduct, addToCartFromList?: boolean) =>
      allowAddToCartFromListing || addToCartFromList
        ? {
            ...productHelper.convertNewProductCard(el, {
              cart,
              frames,
              hasBrand,
              showUom,
              contactLink,
            }),
          }
        : productHelper.convertNewProductCard(el, {
            frames,
            hasBrand,
            showUom,
          }),
    [cart, frames],
  );
  return { convertNewProductCard };
};
